<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class="" elevation="" max-width="">
                    <v-card-title class="justify-space-between"> 
                        <span>
                            <v-icon left>mdi-format-list-bulleted</v-icon>
                            Lista de Tratamientos Modal 
                        </span>
                        <v-btn color="primary" @click="handleAddTratamientoModal">
                            <v-icon left>mdi-plus</v-icon>
                            Nuevo Tratamiento Modal
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <!-- Filtros de busqueda -->
                        <v-row>
                            <v-col cols="12" md="8">
                                 <v-text-field
                                    label="Buscar por nombre"
                                    v-model="filtros.search"
                                    @keyup.enter="getData"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="d-flex align-center gap-2">
                                <v-btn color="primary" @click="getData">Buscar</v-btn>
                                <v-btn color="secondary" @click="resetFilters">Limpiar</v-btn>
                            </v-col>
                        </v-row>


                        <v-data-table
                            :headers="table.headers"
                            :items="table.data.data"
                            :options.sync="table.options"
                            :items-per-page="table.options.itemsPerPage"
                            :server-items-length="table.data.total"
                            class="elevation-1"
                            @update:options="changeOptionsTable"
                        >
                            <template v-slot:item.id="{ item }">
                                {{ formatCode(item.id) }}
                            </template>

                            <template v-slot:item.contenido="{ item }">
                                {{ reduceText(item.contenido, 50) }}
                            </template>

                            <!-- <template v-slot:item.imagen="{ item }">
                                <v-img
                                    v-if="item.imagen"
                                    :src="assetAWS(item.imagen)"
                                    width="100"
                                    height="50"
                                    contain
                                    class="bg-img-tenue"
                                />
                                <span v-else>Sin imagen</span>
                            </template> -->

                            <template v-slot:item.estado="{ item }">
                                <v-chip :color="item.estado == 1 ? 'green' : 'red'" dark>
                                    {{ item.estado == 1 ? 'Activo' : 'Inactivo' }}
                                </v-chip>
                            </template>

                            <template v-slot:item.acciones="{ item }">
                                <div class="d-flex gap-2">
                                    <v-btn icon small color="primary" @click="handleEditTratamientoModal(item)">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon small color="red" @click="handleDeleteTratamientoModal(item)">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>

                            </template>
                                        

                            <template v-slot:no-data>
                                No hay tratamientos para mostrar
                            </template>

                        </v-data-table>


                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>


        <!-- Modal nuevo tratamiento modal -->
        <ModalCard
            v-model="modal.addTratamientoModal.show"
            max-width="900px"
            @cancel="resetModal('addTratamientoModal')"
            >
            <template #title>
                <v-icon left>mdi-plus</v-icon>
                Nuevo Tratamiento Modal
            </template>

            <FormTratamientoModal
                class="p-form"
                v-model="modal.addTratamientoModal.tratamientoModal"
                @submit="handleStoreTratamientoModal"
                @cancel="resetModal('addTratamientoModal')"
            />
        </ModalCard>

        <!-- Modal editar tratamiento modal -->
        <ModalCard
            v-model="modal.editTratamientoModal.show"
            max-width="900px"
            @cancel="resetModal('editTratamientoModal')"
            >
            <template #title>
                <v-icon left>mdi-pencil</v-icon>
                Editar Tratamiento Modal #{{ formatCode(modal.editTratamientoModal.tratamientoModal?.id || '') }}
            </template>

            <FormTratamientoModal
                class="p-form"
                v-model="modal.editTratamientoModal.tratamientoModal"
                @submit="handleUpdateTratamientoModal"
                @cancel="resetModal('editTratamientoModal')"
            />
        </ModalCard>

        <!-- Modal eliminar tratamiento modal -->
        <ModalDelete
            v-model="modal.deleteTratamientoModal.show" 
            @destroy="handleDestroyTratamientoModal"
            @cancel="resetModal('deleteTratamientoModal')"
        />
    </v-container>
</template>

<script >
    import tratamientoModalService from '@/services/tratamientoModalService';
    import { tratamientoModal } from '@/models/tratamientoModal';

    import ModalCard from '@/components/ModalCard.vue';
    import ModalDelete from '@/components/ModalDelete.vue';
    import FormTratamientoModal from '@/components/tratamientos/modal/FormTratamientoModal.vue';

    const modals = _ => ({
        addTratamientoModal: {
            show: false,
            loading: false,
            tratamientoModal: null,
        },
        editTratamientoModal: {
            show: false,
            loading: false,
            tratamientoModal: null,
        },
        deleteTratamientoModal: {
            show: false,
            loading: false,
            tratamientoModal: null,
        },
    })

    export default {
        name: "TratamientosModalIndex",
        components: {
            ModalCard,
            ModalDelete,
            FormTratamientoModal,
        },
        data() {
            return {
                resources: {
                },
                table: {
                    headers: [
                        { text: 'ID', value: 'id' },
                        { text: 'Titulo', value: 'titulo' },
                        { text: 'Contenido', value: 'contenido' },
                        // { text: 'Imagen', value: 'imagen' },
                        { text: 'Estado', value: 'estado' },
                        {
                            text: 'Acciones',
                            value: 'acciones',
                            align: 'center',
                            sortable: false,
                        }
                    ],
                    options: {
                        page: 1,
                        itemsPerPage: 15,
                        sortBy: [],
                        sortDesc: [],
                    },
                    data: {
                        data: [],
                        total: 0,
                    }

                },
                filtros: {
                    search: '',
                },
                modal: modals(),
            }
        },
        methods: {
            async getData() {

                const options = this.table.options;

                const page = options.page || 1;
                const perPage = options.itemsPerPage || 15;
                const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : null;
                const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
                const search = this.filtros.search || '';


                try {
                    const res = await tratamientoModalService.paginate({
                        page: page,
                        per_page: perPage,
                        search: search,
                        sort_by: sortBy,
                        sort_desc: sortDesc !== null ? (sortDesc ? 'desc' : 'asc') : null,
                    });
                    this.table.data = res.data;

                    
                } catch (error) {
                    console.error(error);
                }
            },

            changeOptionsTable(options) {
                this.table.options = options;
                this.getData();
            },


            resetOptionsTable() {
                this.table.options.page = 1;
                this.table.options.itemsPerPage = 15;
                this.table.options.sortBy = [];
                this.table.options.sortDesc = [];
            },

            resetFilters() {
                this.filtros.search = '';

                this.resetOptionsTable();
                this.getData();
            },


            handleAddTratamientoModal() {
                this.modal.addTratamientoModal.tratamientoModal = {...tratamientoModal };
                this.modal.addTratamientoModal.show = true;
            },
            handleEditTratamientoModal(tratamientoModal) {
                this.modal.editTratamientoModal.tratamientoModal = tratamientoModal;
                this.modal.editTratamientoModal.show = true;
            },
            handleDeleteTratamientoModal(tratamientoModal) {
                this.modal.deleteTratamientoModal.tratamientoModal = tratamientoModal;
                this.modal.deleteTratamientoModal.show = true;
            },


            async handleStoreTratamientoModal(form) {

                try {

                    const formData = new FormData();
                    for (const key in form) {
                        if (form[key] !== undefined && form[key] !== null) {
                            formData.append(key, form[key]);
                        }
                    }

                    const response = await tratamientoModalService.store(formData);
                    
                    this.table.options.page = 1;
                    await this.getData();

                    this.resetModal('addTratamientoModal');
                    this.$toasted.success('Modal creado correctamente.');

                } catch (error) {
                    this.handleErrorApi(error);
                }
            },
            async handleUpdateTratamientoModal(form) {
                console.log("🚀 ~ form:", form)
                try {
                    const formData = new FormData();
                    formData.append('_method', 'PUT');
                    for (const key in form) {
                        if (form[key] !== undefined && form[key] !== null) {
                            formData.append(key, form[key]);
                        }
                    }

                    const response = await tratamientoModalService.update(form.id, formData);
                    
                    await this.getData();

                    this.resetModal('editTratamientoModal');
                    this.$toasted.success('Modal actualizado correctamente.');
                } catch (error) {
                    this.handleErrorApi(error);
                }
            },
            async handleDestroyTratamientoModal() {
                try {
                    const modal = this.modal.deleteTratamientoModal.tratamientoModal;

                    const formData = new FormData();
                    formData.append('_method', 'DELETE');
                    
                    await tratamientoModalService.destroy(modal.id, formData);

                    this.table.options.page = 1;
                    await this.getData();

                    this.resetModal('deleteTratamientoModal');
                    this.$toasted.success('Modal eliminado correctamente.');
                } catch (error) {
                    this.handleErrorApi(error);
                }
            },

            resetModal(modalName) {
                const modales = modals();

                if ( !modales.hasOwnProperty(modalName) ) {
                    console.warn(`El modal ${modalName} no existe.`);
                    return;
                }

                this.modal[modalName] = modales[modalName];
            }
        }
    }
</script>

<style scoped>
    .gap-2 {
        gap: 8px;
    }
</style>